import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ordersService from './ordersService';


export const orders = createAsyncThunk('subreseller/orders', async (params, {rejectWithValue}) => {
    try {
        const response = await ordersService.orders(params);
        return response;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return rejectWithValue(message);
    }
});

export const orderDetail = createAsyncThunk('subreseller/orders/detail', async (params, {rejectWithValue}) => {
    try {
        const response = await ordersService.ordersDetail(params);
        
        return response.data[0];

    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return rejectWithValue(message);
    }
});

export const orderCreate = createAsyncThunk('subreseller/orders/create', async (data, {rejectWithValue}) => {
    try {
        const response = await ordersService.createOrder(data);
        return response;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return rejectWithValue(message);
    }
});

export const orderFinalize = createAsyncThunk('subreseller/orders/finalize', async (data, {rejectWithValue}) => {
    try {
        const response = await ordersService.finalizeOrder(data);
        return response;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return rejectWithValue(message);
    }
});


const initialState = {
    orders: {},
    orderDetail:{},
    orderSummary:{},
    isError: false,
    isLoading: false,
    isSuccess: false,
    isDetailSuccess: false,
    isDetailLoading: false,
    isDetailError: false,
    isCreateSuccess: false,
    isCreateLoading: false,
    isCreateError: false,
    isFinalizeSuccess: false,
    isFinalizeLoading: false,
    isFinalizeError: false,
    message: '',
    
};

export const ordersSlice = createSlice({
    name: 'subresellerOrders',
    initialState,
    reducers: {
        reset: (state) => {
            state.isError = false;
            state.isSuccess = false;
            state.isLoading = false;
            state.isDetailSuccess = false;
            state.isDetailLoading = false;
            state.isDetailError = false;
            state.isCreateSuccess = false;
            state.isCreateLoading = false;
            state.isCreateError = false;
            state.isFinalizeSuccess = false;
            state.isFinalizeLoading = false;
            state.isFinalizeError = false;
            state.message = '';
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(orders.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(orders.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.orders = action.payload;
            })
            .addCase(orders.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
        builder
            .addCase(orderDetail.pending, (state) => {
                state.isDetailLoading = true;
            })
            .addCase(orderDetail.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isDetailSuccess = true;
                state.orderDetail = action.payload;
            })
            .addCase(orderDetail.rejected, (state, action) => {
                state.isDetailLoading = false;
                state.isDetailError = true;
                state.isDetailSuccess = false;
                state.message = action.payload;
            });
        builder
            .addCase(orderCreate.pending, (state) => {
                state.isCreateLoading = true;
            })
            .addCase(orderCreate.fulfilled, (state, action) => {
                state.isCreateLoading = false;
                state.isCreateSuccess = true;
                state.orderSummary = action.payload;
            })
            .addCase(orderCreate.rejected, (state, action) => {
                state.isCreateLoading = false;
                state.isCreateError = true;
                state.isCreateSuccess = false;
                state.message = action.payload;
            });
            builder
            .addCase(orderFinalize.pending, (state) => {
                state.isFinalizeLoading = true;
            })
            .addCase(orderFinalize.fulfilled, (state, action) => {
                state.isFinalizeLoading = false;
                state.isFinalizeSuccess = true;
                //state.orderDetail = action.payload;
            })
            .addCase(orderFinalize.rejected, (state, action) => {
                state.isFinalizeLoading = false;
                state.isFinalizeError = true;
                state.isFinalizeSuccess = false;
                state.message = action.payload;
            });
    }
})

export const {reset} = ordersSlice.actions;
export default ordersSlice.reducer;